<template>
  <admin-layout>
    <template slot="content">
      <header-for-list-component
          sectionName="Tipos de Documento"
          :items="documentTypes"
          :totalItems="totalItems"
          :totalPages="totalPages"
          :itemsPerPage="itemsPerPage"
          :pageNumber.sync="pageNumber"
          @loadPage="loadPage($event)"
      />

      <v-layout
          align-center
          justify-space-between
          class="mb-3"
      >
        <v-flex xs4>
          <v-text-field
              v-model="search"
              solo
              label="Buscar Tipo de Documento"
              prepend-inner-icon="mdi-magnify"
              hide-details
              :loading="loadingSearch"
              @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                  v-if="loadingSearch"
                  color="accent"
                  indeterminate
                  height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
            xs4
            class="text-xs-right">
          <create-or-update
              mode="create"
              :documentType="null"
              @loadPage="loadPage(pageNumber)"
          ></create-or-update>

        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
            :headers="headers"
            :items="documentTypes"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.code }}</td>
            <td>{{ translateCategory(props.item.category) }}</td>
            <td>{{ props.item.name }}</td>
            <td>
              <v-layout row>

                <create-or-update
                    mode="edit"
                    :documentType="Object.assign({}, props.item)"
                    @loadPage="loadPage(pageNumber)">
                </create-or-update>

                <delete :documentType="props.item"></delete>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout';

import CreateOrUpdate from '@/components/configurations/document_types/CreateOrUpdate';
import Delete from '@/components/configurations/document_types/Delete';
import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
import DocumentTypeService from '@/services/applications/configurations/DocumentTypeService';

export default {
  name: 'List',
  components: {
    AdminLayout,
    HeaderForListComponent,
    CreateOrUpdate,
    Delete
  },
  mounted() {
    this.loadPage(1);
  },
  data() {
    return {
      search: '',
      documentTypes: [],
      loadingSearch: false,
      interval: null,
      totalItems: 0,
      totalPages: 0,
      itemsPerPage: 20,
      pageNumber: 1,
      headers: [
        { text: 'ID', value: 'id', sortable: false, align: 'center' },
        { text: 'Código', value: 'code', sortable: false, align: 'center' },
        { text: 'Categoria', value: 'category', sortable: false, align: 'center' },
        { text: 'Nome', value: 'name', sortable: false, align: 'center' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' }],
    };
  },
  methods: {
    loadPage(pageNumber) {
      this.pageNumber = pageNumber || this.pageNumber;
      if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
      DocumentTypeService
        .all({
          page: this.pageNumber,
          q: this.search,
        })
        .then(({ data }) => {
          this.documentTypes = data.document_types || [];
          this.totalItems = data.total;
          this.totalPages = data.total_pages;
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
          this.loadingSearch = false;
        });
    },
    typing() {
      clearInterval(this.interval)
      this.interval = setTimeout(() => {
        this.loadingSearch = true;
        this.pageNumber = 1;
        this.loadPage();
      }, 500);
    },
    translateCategory(item) {
      const cats = { basic: 'Básico', technic: 'Técnico', specific: 'Específico' }
      return cats[item]
    }
  },
};
</script>

<style scoped lang="scss">
</style>
